import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { ConfirmButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BoostIllustration from '../BoostIllustration';

interface Props {
  onRequestClose: () => void;
}

const AlreadyBoostedModal: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <MessageModal
      isOpen
      variant="vertical"
      image={<BoostIllustration />}
      onRequestClose={onRequestClose}
      title={t('boostDeviation.alreadyBoostedModal.title')}
      message={t('boostDeviation.alreadyBoostedModal.message')}
      footerButtons={[
        <ConfirmButton key="confirm" onClick={onRequestClose}>
          {t('common.gotIt')}
        </ConfirmButton>,
      ]}
    />
  );
};
AlreadyBoostedModal.displayName = 'AlreadyBoostedModal';

export default AlreadyBoostedModal;
